module.exports = __webpack_public_path__ + "static/burnside-logo-79431aa8120c2e6199759684edd610f0.jpeg";